import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import {
  AddIcon,
  CloseIcon,
  MicIcon,
  NotInLocationPicture,
  StopIcon
} from "../../Assets/assets";
import AudioPlayer from "../../Components/AudioPlayer/AudioPlayer";
import Button from "../../Components/Button/Button";
import { ShareCard } from "../../Components/Cards/Cards";
import CropperModal from "../../Components/CropperModal/CropperModal";
import Header from "../../Components/Header/Header";
import InputBox from "../../Components/InputBox/InputBox";
import Modal from "../../Components/Modal/Modal";
import TrackProgress from "../../Components/TrackProgress/TrackProgress";
import useVoiceRecorder, {
  voiceRecorderTimeLimit
} from "../../CustomHooks/useVoiceRecorder";
import {
  fetchSelectedComplaintAssets,
  reopenComplaint,
  setSelectedComplaint,
  updateLinkComplaint
} from "../../Redux/complaints/action";
import { setSelectedLocation } from "../../Redux/locations/action";
import { setErrorStatus } from "../../Redux/status/action";
import { isValidArray, isValidObject } from "../../Services/validators";
import {
  alignPhoneNumber,
  dateAndTimeConverter,
  getAppsUrls,
  LocationFallBack,
  locationRange,
  openInNewTab,
  PermissionDeniedFallback
} from "../../Utils/constants";
import {
  getComplaintDetailsData,
  ImageViewer
} from "../../Utils/Constants/complaints";

function SelectedComplaint(props) {
  const { complaintId } = useParams();
  const [isDisabled, setIsDisabled] = useState(true);
  const [running, setRunning] = useState(false);
  const [croppedImage, setCroppedImage] = useState([]);
  const [file, setFile] = useState({ image: [], audio: null });
  const [formData, setFormData] = useState({
    description: ""
  });
  const [show, setShow] = useState({
    linkedPhoneNumbers: false,
    updates: false,
    image: null,
    reopen: false,
    share: false
  });

  useEffect(() => {
    if (complaintId) {
      props.setSelectedComplaint(complaintId, props.navigate);
    }
    return () => {
      setSelectedComplaint(null);
    };
    // eslint-disable-next-line
  }, []);

  // const getTurnaroundTime = (timestamp) => {
  //   const hours = timestamp / (1000 * 60 * 60);

  //   if (hours % 24 === 0) {
  //     return `${hours / 24} Days`;
  //   } else {
  //     return `${hours} Hour${hours !== 1 ? "s" : ""}`;
  //   }
  // };
  useEffect(() => {
    const { description } = formData;

    const isValid =
      description?.length > 0 &&
      (croppedImage.length > 0 || file.audio) &&
      !running;

    setIsDisabled(!isValid);
  }, [formData, file, croppedImage, running]);

  const handleLinkComplaint = () => {
    const linkedWith =
      props.complaints?.selectedComplaint?.issuedBy?.linkedWith || [];
    const { phoneNumber, name, sourceType, callId } = props.formData;

    const alreadyLinked = linkedWith.some(
      (el) => el.userDetails?.phoneNumber === phoneNumber
    );

    if (alreadyLinked) {
      setErrorStatus({
        code: "custom",
        message: "Already linked with this compliant"
      });
      return;
    }

    if (phoneNumber?.replace("+91", "")?.length !== 10) {
      setErrorStatus({
        code: "custom",
        message: "Please enter valid phone number"
      });
      return;
    }

    const newLink = {
      source: {
        type: sourceType,
        ...(callId ? { callId } : {})
      },
      issuedAt: Date.now(),
      userDetails: {
        phoneNumber: phoneNumber,
        ...(name ? { name: name } : {})
      }
    };

    props.updateLinkComplaint(
      props.complaints?.selectedComplaint?.documentId,
      newLink
    );

    props.clearFormData();
  };

  useEffect(() => {
    if (!complaintId) {
      return;
    }

    let isCancelled = false;

    const fetchUntilAssetsAvailable = () => {
      if (!isValidObject(props.complaints?.selectedComplaint)) {
        return;
      }

      const rootAssetCount = isValidArray(
        props.complaints?.selectedComplaint.assets
      )
        ? props.complaints?.selectedComplaint.assets.length
        : 0;

      const rootProofCount =
        (props.complaints?.selectedComplaint.fileSrc?.images?.length || 0) +
        (props.complaints?.selectedComplaint.fileSrc?.audio ? 1 : 0);

      const isRootAssetIncomplete =
        rootAssetCount > 0 && rootProofCount !== rootAssetCount;

      const updates = props.complaints?.selectedComplaint.latestUpdate || [];

      const updatesNeedAssets = updates.some((update) => {
        if (!update.proof) {
          return false;
        }

        const proofLen = update.proof?.length || 0;
        const fileSrcLen =
          (update.fileSrc?.images?.length || 0) +
          (update.fileSrc?.audio ? 1 : 0);

        return proofLen !== fileSrcLen;
      });

      if (!isCancelled && (isRootAssetIncomplete || updatesNeedAssets)) {
        fetchSelectedComplaintAssets();
      } else if (!isRootAssetIncomplete && !updatesNeedAssets) {
        return;
      }
    };

    fetchUntilAssetsAvailable();

    return () => {
      isCancelled = true;
    };
    // eslint-disable-next-line
  }, [complaintId, props.complaints?.selectedComplaint]);
  return (
    <div className="inherit-parent-width inherit-parent-height flex-center-children-horizontally">
      <div className="max-width-767px inherit-parent-width inherit-parent-height">
        <Header
          backOnClick={() => {
            props.navigate("/compliant");
            setSelectedComplaint(null);
            setSelectedLocation(null);
          }}
          title="Selected Complaint"
          shareOnclick={() =>
            setShow((prev) => ({
              ...prev,
              share: true
            }))
          }
        />
        <div className="padding-larger parent-height-sub-64px ">
          <div className="inherit-parent-height display-flex flex-direction-column flex-justify-content-space-between">
            <div
              style={{
                height: props.formData.phoneNumber
                  ? "calc(100% - 60px)"
                  : "100%",
                overflow: "scroll"
              }}
            >
              {getComplaintDetailsData(
                props.complaints?.selectedComplaint,
                setShow
              ).map((data, i) => (
                <React.Fragment key={i}>
                  <div className="font-size-smaller padding-bottom-default">
                    {data.title}
                  </div>
                  <div
                    className={`padding-bottom-large font-size-medium text-capitalize `}
                  >
                    {typeof data.value === "string" &&
                    data.title !== "COMPLAINT ID"
                      ? data.value.toLowerCase()
                      : data.value}
                  </div>
                </React.Fragment>
              ))}
            </div>

            {props.formData.phoneNumber.replace("+91", "")?.length === 10 &&
              props.complaints?.selectedComplaint?.status?.currentStatus ===
                "OPEN" && (
                <Button
                  text="Link complaint"
                  data-cy={
                    props.complaints.loading || props.complaintsLoading.assets
                      ? "link-compliant-button-loading"
                      : "link-compliant-button"
                  }
                  type="button"
                  boxShadow={false}
                  loading={props.complaints.loading}
                  onClick={() => {
                    handleLinkComplaint();
                  }}
                />
              )}
            {props.complaints?.selectedComplaint?.status?.currentStatus ===
              "PENDING CLOSURE" && (
              <Button
                text="Reopen"
                data-cy="REOPEN-COMPLIANT-BUTTON"
                type="button"
                boxShadow={false}
                loading={props.complaints.loading}
                onClick={() => {
                  setShow((prev) => ({
                    ...prev,
                    reopen: true
                  }));
                }}
              />
            )}
          </div>
        </div>

        <Modal
          show={typeof show.image === "string"}
          canIgnore={true}
          onClose={() => {
            setShow((prev) => ({
              ...prev,
              image: false
            }));
          }}
          width="inherit-parent-width"
          maxWidth="inherit-parent-width"
          background="false"
          boxShadow="false"
          zIndex={105}
        >
          <div
            data-cy="image-view-modal"
            className="inherit-parent-height font-family-gilroy-regular font-color-secondary"
          >
            <img
              className="inherit-parent-width"
              data-cy="view-proof-image"
              src={show.image}
              alt="images"
            />
          </div>
        </Modal>

        <Modal
          show={show.linkedPhoneNumbers === true}
          canIgnore={true}
          onClose={() => {
            setShow((prev) => ({
              ...prev,
              linkedPhoneNumbers: false
            }));
          }}
          position="position-fixed bottom-0 left-0 right-0"
          width="inherit-parent-width"
          maxWidth="inherit-parent-width"
          height="height-40-percentage"
          boxShadow="false"
        >
          <div className="background-white padding-large inherit-parent-height">
            <div className="text-align-center padding-bottom-large font-size-medium">
              LINKED COMPLAINTS
            </div>
            <div
              style={{
                height: "calc(100% - 40px)"
              }}
              className="overflow-scroll"
            >
              {props.complaints?.selectedComplaint?.issuedBy?.linkedWith?.map(
                (data, index) => (
                  <div
                    key={index}
                    data-cy={`contact-${data?.userDetails?.phoneNumber}`}
                    className={` ${
                      index === 0 ? "" : "padding-top-default"
                    } display-flex padding-bottom-default flex-justify-content-space-between flex-align-items-center`}
                  >
                    <div>
                      <div className="padding-bottom-small">
                        {data?.userDetails?.name || "NOT PROVIDED"}
                      </div>
                      <div className="font-size-small">
                        {data?.userDetails?.phoneNumber}
                      </div>
                    </div>
                    <div className="font-size-small">
                      {`${dateAndTimeConverter(data?.issuedAt, "cardDate")},
                      ${dateAndTimeConverter(data?.issuedAt, "Time")}`}
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </Modal>

        <Modal
          show={show.updates === true}
          canIgnore={true}
          onClose={() => {
            setShow((prev) => ({
              ...prev,
              updates: false
            }));
          }}
          position="position-fixed bottom-0 left-0 right-0"
          width="inherit-parent-width"
          maxWidth="inherit-parent-width"
          height="height-50-percentage"
          boxShadow="false"
        >
          <div className="background-white padding-large inherit-parent-height">
            <div className="text-align-center padding-bottom-large font-size-medium">
              UPDATES
            </div>
            <div
              style={{
                height: "calc(100% - 40px)"
              }}
              className="overflow-scroll"
            >
              {props.complaints?.selectedComplaint?.latestUpdate?.map(
                (data, index) => (
                  <div key={index}>
                    <TrackProgress
                      title={data.description}
                      state="INACTIVE"
                      isLast={
                        props.complaints?.selectedComplaint?.latestUpdate
                          .length -
                          1 ===
                        index
                      }
                      data={
                        <div className="inherit-parent-width">
                          {data.currentStatus ? (
                            <Fields
                              title="STATUS"
                              data={
                                <div className="display-flex flex-justify-content-center flex-align-items-center width-fit-content">
                                  {data.previousStatus ? (
                                    <>
                                      {getValidCard(data.previousStatus)}
                                      <div className="padding-left-default padding-right-default">
                                        {" "}
                                        &rarr;
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                  {getValidCard(data.currentStatus)}
                                </div>
                              }
                            />
                          ) : (
                            <></>
                          )}
                          <Fields
                            title="UPDATED AT"
                            data={`${dateAndTimeConverter(
                              data.updatedAt,
                              "Time"
                            )}, ${dateAndTimeConverter(
                              data.updatedAt,
                              "secondDate"
                            )}`}
                          />

                          <Fields
                            title="UPDATED BY"
                            data={`${
                              alignPhoneNumber(data?.updatedBy?.phoneNumber) ||
                              data?.updatedBy?.email ||
                              "N/A"
                            } , ${data?.updatedBy?.employeeName || "N/A"}`}
                          />

                          {isValidArray(data.proof) && (
                            <div className="padding-top-large">
                              <div className="padding-bottom-large">
                                SUPPORTING MEDIA
                              </div>
                              <div className="display-flex flex-direction-column">
                                {data.fileSrc?.images.length > 0 ? (
                                  <ImageViewer
                                    images={data.fileSrc.images}
                                    setShow={setShow}
                                  />
                                ) : (
                                  <>IMAGE NOT PROVIDED</>
                                )}

                                <div
                                  style={{
                                    padding: "8px"
                                  }}
                                />

                                {typeof data.fileSrc?.audio === "string" ? (
                                  <AudioPlayer
                                    className="flex-basis-80-percentage"
                                    src={data.fileSrc?.audio}
                                  />
                                ) : (
                                  <>AUDIO NOT PROVIDED</>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      }
                    />
                  </div>
                )
              )}
            </div>
          </div>
        </Modal>

        <Modal
          show={show.reopen === true}
          canIgnore={true}
          onClose={() => {
            setShow((prev) => ({
              ...prev,
              reopen: false
            }));
          }}
          position="position-fixed bottom-0 left-0 right-0"
          width="inherit-parent-width"
          maxWidth="inherit-parent-width"
          height="height-fit-content"
          boxShadow="false"
        >
          <div
            className="background-white padding-large display-flex flex-direction-column"
          >
            <div className="text-align-center padding-bottom-large font-size-medium">
              REOPEN COMPLAINT
            </div>
            <div className="flex-grow-1 overflow-y-auto">
              {props.locationAccess !== "granted" && !window.Cypress && (
                <PermissionDeniedFallback
                  hideHeader={true}
                  fallBackImage={<LocationFallBack />}
                  title={
                    props.locationAccess === "prompt"
                      ? "Allow Location Permission"
                      : "Location Permission Denied"
                  }
                  description={
                    props.locationAccess === "prompt"
                      ? "Enables us to monitor your real-time location"
                      : "You have blocked from tracking your location. To use this, change your location settings in browser."
                  }
                  showButton={props.locationAccess === "prompt"}
                  onEnableClick={() => {
                    props.requestLocationPermission();
                  }}
                  navigate={props.navigate}
                  profileOnClick={() => {
                    props.navigate("/settings");
                  }}
                />
              )}

              {props.locationAccess === "granted" &&
                (props.locations.distance === null ||
                  props.locations?.distance > locationRange) && (
                  <div className="remaining-procedure-height padding-horizontal-large display-flex flex-direction-column flex-justify-content-center flex-align-items-center">
                    <div
                      style={{
                        padding: "60px 0 60px 0"
                      }}
                      data-cy="notInLocation-fallBack"
                    >
                      <NotInLocationPicture />
                    </div>
                    <div className="padding-top-larger font-size-default">
                      Not in location ?
                    </div>
                    <div className="padding-top-medium text-align-center font-size-medium">
                      Reach the assigned location to reopen complaint.
                    </div>
                    <div
                      onClick={() => {
                        openInNewTab(
                          `${getAppsUrls.public.url}/${
                            props.complaints.selectedComplaint?.location?.id
                          }`
                        );
                      }}
                      className="padding-top-medium font-size-small font-color-primary text-underline"
                    >
                      Can't reach ?
                    </div>
                  </div>
                )}

              {props.locations.distance !== null &&
                props.locations.distance <= locationRange && (
                  <div className="inherit-parent-width">
                    <form
                      onChange={(event) => {
                        setFormData({
                          ...formData,
                          [event.target.name]: event.target.value
                        });
                      }}
                      onSubmit={(event) => {
                        event.preventDefault();
                        const profile = props.profile.data;

                        const data = {
                          locationId:
                            props.complaints?.selectedComplaint?.location.id,
                          complaintId:
                            props.complaints?.selectedComplaint?.documentId,
                          description: formData.description,
                          employee: {
                            employeeId: profile.employeeId,
                            employeeName: profile.name,
                            phoneNumber: profile.phoneNumber
                          }
                        };

                        const proof = file.audio
                          ? [...croppedImage, file.audio]
                          : croppedImage;

                        reopenComplaint(data, proof, props.navigate);

                        setShow({
                          linkedPhoneNumbers: false,
                          updates: false,
                          image: null,
                          reopen: false
                        });
                      }}
                    >
                      <InputBox
                        name="description"
                        type="text"
                        removeResponsive={true}
                        label="DESCRIPTION"
                        value={formData.description}
                      />

                      <UploadFiles
                        file={file}
                        setFile={setFile}
                        croppedImage={croppedImage}
                        setCroppedImage={setCroppedImage}
                        running={running}
                        setRunning={setRunning}
                        name="REOPEN-UPLOAD-FILES"
                      />

                      <Button
                        text="UPLOAD"
                        data-cy="REOPEN_UPLOAD_CONFIRM-BUTTON"
                        type="submit"
                        boxShadow={false}
                        loading={props.complaints?.loading}
                        disabled={isDisabled}
                      />
                    </form>
                  </div>
                )}
            </div>
          </div>
        </Modal>

        <Modal
          show={isValidArray(file?.image)}
          canIgnore={true}
          onClose={() => {
            setFile({ ...file, image: [] });
          }}
          width="inherit-parent-width"
          maxWidth="max-width-800px"
          background="false"
          boxShadow="false"
          borderRadius="false"
          height="inherit-parent-height max-height-500px"
        >
          <div
            data-cy="cropper-modal"
            className={`background-white inherit-parent-height border-radius-default box-shadow-default font-family-gilroy-regular font-color-secondary`}
          >
            <CropperModal
              className="border-radius-default"
              OnBlobCreate={(blob) => {
                const imageFile = new File([blob], `${+new Date()}.png`, {
                  type: "image/png"
                });
                setCroppedImage([...croppedImage, imageFile]);
              }}
              file={file.image}
              setFile={() => {
                setFile({ ...file, image: [] });
              }}
            />
          </div>
        </Modal>
      </div>
      {/* <Modal
        show={show.share === true}
        canIgnore={true}
        onClose={() => {
          setShow((prev) => ({
            ...prev,
            share: false
          }));
        }}
        position="position-fixed bottom-0 left-0 right-0"
        width="inherit-parent-width"
        maxWidth="inherit-parent-width"
        height="height-50-percentage"
        boxShadow="false"
      > */}
      <Modal
        show={show.share === true}
        canIgnore={true}
        onClose={() => {
          setShow((prev) => ({
            ...prev,
            share: false
          }));
        }}
        width="inherit-parent-width"
        maxWidth="none"
        minWidth="none"
        height="none"
        position="position-absolute bottom-0 right-0 left-0"
        borderRadius="false"
      >
        <div
          className="font-color-tertiaryColor margin-larger"
          style={{ width: "calc(100% - 48px)" }}
          data-cy="SHARE-MODAL"
        >
          <div className="flex-justify-content-center flex-direction-column flex-align-items-center ">
            <div className="font-size-large margin-bottom-small padding-bottom-smaller">
              Share Complaint
            </div>
            <div className="font-color-tertiaryColor6 font-size-medium margin-bottom-larger">
              Can access the complaint through connected apps
            </div>
          </div>
          <div
            className="display-flex flex-direction-column"
            style={{ gap: "24px" }}
          >
            {Object.values(getAppsUrls).map((data) => {
              const isPublic = data.key === "public";
              if (isPublic) {
                return null;
              }
              return (
                <ShareCard
                  key={data.key}
                  data={data}
                  complaintId={props.complaints?.selectedComplaint?.documentId}
                />
              );
            })}
          </div>
        </div>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => ({
  complaints: state.complaints,
  locations: state.locations,
  profile: state.profile
});

const mapDispatchToProps = () => ({
  updateLinkComplaint: (documentId, data) =>
    updateLinkComplaint(documentId, data),
  setSelectedComplaint: (documentId, navigate) =>
    setSelectedComplaint(documentId, navigate)
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectedComplaint);

export const Fields = (props) => {
  return (
    <div className="display-flex padding-top-large">
      <div className="display-flex">
        <div
          className="white-space-no-wrap font-color-tertiaryColor6"
          style={{ width: "150px" }}
          data-cy={`${props.title}`}
        >
          {props.title}
        </div>
      </div>
      <div
        className={`text-align-left inherit-parent-width text-overflow-ellipsis font-color-tertiaryColor ${
          !props.removeCapitalize && "text-capitalize"
        }`}
        data-cy={props.dataCy || props.data}
        style={{
          // minWidth: "fit-content",
          // maxWidth: "380px",
          textWrap: "wrap"
        }}
      >
        {props.data}
      </div>
    </div>
  );
};

const UploadFiles = (props) => {
  const { startRecording, saveRecording } = useVoiceRecorder();
  const [recordedAudio, setRecordedAudio] = useState({
    audioBlob: false,
    audioURL: ""
  });

  const [voiceRecorderControl, setVoiceRecorderControl] = useState(null);
  const [counter, setCounter] = useState(null);

  useEffect(() => {
    if (recordedAudio.audioURL) {
      setVoiceRecorderControl(null);
    }
  }, [recordedAudio.audioURL]);

  const handleAudioRecording = useCallback(async () => {
    if (voiceRecorderControl === null || voiceRecorderControl === "cancel") {
      setVoiceRecorderControl("start");
      setCounter(0);
      props.setRunning(true);

      const res = await startRecording();
      if (res === false) {
        setVoiceRecorderControl(null);
      }
    } else if (voiceRecorderControl === "start") {
      setVoiceRecorderControl("stop");
      setCounter(null);
      props.setRunning(false);

      const resBlob = await saveRecording();
      const audioURL = URL.createObjectURL(resBlob);
      const audioFile = new File([resBlob], `${Date.now()}.mp3`, {
        type: "audio/mp3"
      });

      setRecordedAudio({ audioBlob: resBlob, audioURL });
      props.setFile((prev) => ({ ...prev, audio: audioFile }));
    } else {
      setVoiceRecorderControl("cancel");
      setRecordedAudio({ audioBlob: false, audioURL: "" });
    }
    // eslint-disable-next-line
  }, [voiceRecorderControl, startRecording, saveRecording]);

  useEffect(() => {
    if (
      props.running &&
      typeof counter === "number" &&
      counter <= voiceRecorderTimeLimit
    ) {
      const timer = setTimeout(() => setCounter((c) => c + 1), 1000);
      return () => clearTimeout(timer);
    }

    if (counter === voiceRecorderTimeLimit) {
      setVoiceRecorderControl("stop");
      handleAudioRecording();
    }
  }, [counter, props.running, handleAudioRecording]);

  const handleImageUpload = (e) => {
    const fileInput = e.target.files?.[0];
    if (!fileInput) return;

    const isValidType = ["image/png", "image/jpeg", "image/jpg"].includes(
      fileInput.type
    );
    if (!isValidType) {
      return setErrorStatus({
        code: "custom",
        message: "Kindly upload a valid File"
      });
    }

    props.setFile((prev) => ({
      ...prev,
      image: [...prev.image, URL.createObjectURL(fileInput)]
    }));
  };

  const handleImageRemove = (name) => {
    props.setCroppedImage((prev) => prev.filter((img) => img.name !== name));
  };

  const handleAudioClear = () => {
    setRecordedAudio({ audioBlob: false, audioURL: "" });
    props.setFile((prev) => ({ ...prev, audio: null }));
  };

  return (
    <div className="padding-top-large">
      <div className="padding-bottom-large font-family-RHD-regular">
        TAKE IMAGES
      </div>
      <div className="display-flex">
        {props.croppedImage?.map((data, index) => (
          <div
            key={index}
            style={{ height: "56px" }}
            className="margin-right-large position-relative"
            data-cy={`uploaded-image-thumbnail-${index}`}
          >
            <div
              onClick={() => handleImageRemove(data.name)}
              data-cy="remove-uploaded-image-button"
              className="background-color-grey width-fit-content border-radius-100-percentage flex-align-items-center flex-justify-content-center position-absolute right-0 opacity-60-percent"
            >
              <CloseIcon />
            </div>
            <img
              className="border-radius-default"
              height={56}
              width={56}
              src={URL.createObjectURL(data)}
              alt="data"
            />
          </div>
        ))}

        <form className="inherit-parent-width" onChange={handleImageUpload}>
          <div className="height-width-56px margin-bottom-default cursor-pointer">
            <label>
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                name={props.name}
                onClick={(e) => (e.target.value = "")}
                className="visibility-hidden position-absolute"
              />
              {(!isValidArray(props.croppedImage) ||
                props.croppedImage.length <= 4) && (
                <div
                  className="background-color-secondary height-width-56px display-flex flex-justify-content-center flex-align-items-center border-radius-default padding-top"
                  data-cy="file-upload-icon"
                >
                  <AddIcon />
                </div>
              )}
            </label>
          </div>
        </form>
      </div>

      <div className="padding-top-large font-family-RHD-regular">
        ADD VOICE NOTES (OPTIONAL)
      </div>
      <div className="flex-justify-content-space-center margin-vertical-large flex-align-items-center">
        {recordedAudio.audioURL ? (
          <AudioPlayer
            className="flex-basis-80-percentage"
            closeOnClick={handleAudioClear}
            src={recordedAudio.audioURL}
          />
        ) : (
          <div className="flex-justify-content-space-between inherit-parent-width flex-align-items-center">
            <div className="display-flex flex-align-items-center">
              <div
                className="flex-place-children-page-center border-radius-50-percentage"
                onClick={handleAudioRecording}
                data-cy={
                  voiceRecorderControl === "start"
                    ? "stop-record-button"
                    : "start-record-button"
                }
              >
                {voiceRecorderControl === "start" ? <StopIcon /> : <MicIcon />}
              </div>
              <div className="padding-left-large">
                {voiceRecorderControl === "start"
                  ? "Recording..."
                  : "Tap the mic to record audio"}
              </div>
            </div>
            {voiceRecorderControl === "start" && (
              <div style={{ width: 50 }}>
                00:{counter?.toString().padStart(2, "0")}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const getValidCard = (status) => {
  return (
    <div
      style={{
        width: "fit-content",
        height: "fit-content",
        padding: "4px 8px",
        fontSize: "10px",
        borderRadius: "4px",
        backgroundColor:
          status === "CLOSED"
            ? "#00892F29"
            : status === "UNDER REVIEW"
            ? "rgba(246, 201, 88, 0.12)"
            : status === "PENDING CLOSURE"
            ? "rgba(46, 169, 255, 0.12)"
            : "#FF4C4C1A",
        color:
          status === "CLOSED"
            ? "#00892F"
            : status === "UNDER REVIEW"
            ? "rgba(181, 132, 0, 1)"
            : status === "PENDING CLOSURE"
            ? "rgba(0, 150, 255, 1) "
            : "#FF4C4C"
      }}
    >
      <div className="white-space-nowrap">{status}</div>
    </div>
  );
};
